const isLocal = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname.includes('192.168.') ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export const baseUrl = (isLocal) 
	? 'http://localhost:3000/'
	: 'https://www.borisvidosevic.com/cms-dev/';

export const apiUrl = (isLocal) 
	? 'http://localhost/cms_ml/'
	: `https://cms-dev.borisvidosevic.com/`;

export const mediaUrl = (isLocal) 
	? `https://eu2.contabostorage.com/f0862444df7f43509dafc5793d8710e9:develop/`
	: `https://eu2.contabostorage.com/f0862444df7f43509dafc5793d8710e9:dev-cms/`;

export const cdnUrl = (isLocal) 
    ? `https://agewvlkkgp.cloudimg.io/v7/_develop_/`
    : `https://agewvlkkgp.cloudimg.io/v7/_devcms_/`;

export const cdnParams = `?force_format=jpeg`;